import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslate } from 'react-admin';
import { Box, Typography, makeStyles } from '@material-ui/core';
import CustomPoper from '../CustomizedUIs/CustomPoperCalendar';
import OneLineTextField from '../users/CustomTextField';
import { useSelector } from 'react-redux';
import GreenSwitch from '../CustomizedUIs/GreenSwitch';

const useStyles = makeStyles({
    TitleSwitch: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '9px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '11px',
        letterSpacing: '0.36px',
        color: '#4f5064',
    },
});

function SiteLauncher({ onChangeTextValue, value }) {
    const translate = useTranslate();
    const classes = useStyles();

    const [openPoper, setOpenPopper] = useState(false);
    const { isEditing } = useSelector(state => state.tree);
    const { URL, navigationKey, metaData } = value;

    return (
        <Box>
            <Box mt={3.5}>
                <OneLineTextField
                    disabled={!isEditing}
                    id="filled-basic"
                    label={translate('pos.categories.url')}
                    value={URL}
                    onChange={(event) => onChangeTextValue('URL')(event.target.value)}
                    style={{ width: 500 }}
                    endDom={<CustomPoper
                        color={'#e5f1f8'}
                        fontSize={'11px'}
                        open={openPoper}
                        handleClick={() => setOpenPopper(true)}
                        handleClose={() => setOpenPopper(false)}
                        title={translate(`pos.common.url`)}
                        content={translate(`pos.common.contentURL`)}
                        icon={<b>?</b>}
                    />}
                />
            </Box>
            <Box mt={2}>
                <OneLineTextField
                    disabled={!isEditing}
                    id="filled-basic"
                    label={translate(`pos.common.navigationKeys`)}
                    value={navigationKey}
                    onChange={(event) => onChangeTextValue('navigationKey')(event.target.value)}
                    style={{ width: 500 }}
                    endDom={<CustomPoper
                        color={'#e5f1f8'}
                        fontSize={'11px'}
                        open={openPoper}
                        handleClick={() => setOpenPopper(true)}
                        handleClose={() => setOpenPopper(false)}
                        title={translate(`pos.common.navigationKey`)}
                        content={translate(`pos.common.contentNavigationKey`)}
                        icon={<b>?</b>}
                    />}
                />
            </Box>
            <Box style={{ marginTop: 20 }} >
                <Box width={200} display='flex' borderRadius={4} bgcolor='background.paper' my={1} px={1} alignItems='center'>
                    <Box flexGrow={1}>
                        <Typography className={classes.TitleSwitch} >{translate('resources.infoPage.startInactiveBrowser.enable_metadata').toUpperCase()}</Typography>
                    </Box>
                    <GreenSwitch
                        disabled={!isEditing}
                        checked={metaData}
                        onChange={(event) => onChangeTextValue('metaData')(event.target.checked)}
                        size='small'
                    />
                </Box>
            </Box>
        </Box>
    )
}

SiteLauncher.propTypes = {
    onChangeTextValue: PropTypes.func.isRequired,
    value: PropTypes.func.isRequired,
}

export default SiteLauncher;
